<template>
  <section class="home">
    <div class="container">
      <el-carousel height="270px" indicator-position="none">
        <el-carousel-item class="banner"  >
          <img :src="banner1" style="width: 100%;">
<!--          <el-image :src="banner1" style="width: 100%" fit="contain"></el-image>-->
        </el-carousel-item>
        <div class="headerFont">
          <span class="headerFontOne">魅力城轨 &nbsp;  美丽徐州</span><br>
          <span class="headerFontTwo">致力于打造 “最可信赖的公共交通服务者和最具活力的城市发展建设者” 。</span>
        </div>
      </el-carousel>
      <el-row style="background-color: #F3F4F8">
        <el-col :span="16" :offset="4">
          <el-card class="box-card" style="background-color: #F3F4F8" shadow="never">
            <div class="clearfixCopy">
              <span class="intorduction" @click="toggleJianJie">INTRODUCTION</span>
              <span class="synopsisOne">企业简介</span>
              <span class="synopsisTwo">—— <span style="font-weight: 100;font-size: 15px">◯</span> ——</span>
            </div>
            <div class="synopsisOverAll">
              <div v-html="JianjieCon">
                &nbsp;
              </div>
              <div style="margin-left: 20px">
                <img src="../../assets/PC/image1_home.png" width="335px" alt="">
              </div>
              <div class="moreAll">
                <span class="moreFont">{{ btnText }}  </span>
                <img src="../../assets/PC/ckgd_icon_home.png" class="moreImg" alt="">
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row class="home-row" style="background-color: white">
        <el-col :span="16" :offset="4">
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>热门职位</span>
              <span @click="jumpMore" class="jumpMore">更多职位 >></span>
            </div>
            <div class="hotHostAll">
              <div v-for="hot in hotRecruitData" :key="hot.id" class="hotHostUnit" @click="jumpTo(hot.id)">
                <div class="hotHostPost">{{ hot.name }} ></div>
                <div class="hotHostPeop">{{ hot.renum }}人</div>
                <div class="hotHostEdu" ></div>
                <div class="hotHostDate" >{{ hot.JZRQ }} 截止</div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16" :offset="4">
          <el-card class="box-card " style="background-color: #F3F4F8"  shadow="never">
            <div class="clearfixCopy">
              <span class="intorduction">ANNOUNCEMENTS</span>
              <span class="synopsisOne">最新公告</span>
              <span class="synopsisTwo">—— <span style="font-weight: 100;font-size: 10px">◯</span> ——</span>
            </div>
            <div style="display:none">
              <div class="newNoticeItem">
                <div class="newNoticeItemDate">
                  <div class="newNoticeItemDay">02</div>
                  <div class="newNoticeItemYear">2020年6月</div>
                </div>
                <div class="newNoticeRight">
                  <span class="newNoticeTitle">徐州市城市轨道交通有限责任公司</span><br />
                  <div class="newNoticeContent">徐州市城市轨道交通有限责任公司（以下简称“轨道公司”）成立于2012年7月30日，注册资本61.625亿元人民币，由市政府授权市国资委及徐州铜山区、新城区、经济技术开发区所属国资公司共同出资</div>
                </div>
              </div>
              <div class="newNoticeItem">
                <div class="newNoticeItemDate">
                  <div class="newNoticeItemDay">02</div>
                  <div class="newNoticeItemYear">2020年6月</div>
                </div>
                <div class="newNoticeRight">
                  <span class="newNoticeTitle">徐州市城市轨道交通有限责任公司</span><br />
                  <div class="newNoticeContent">徐州市城市轨道交通有限责任公司（以下简称“轨道公司”）成立于2012年7月30日，注册资本61.625亿元人民币，由市政府授权市国资委及徐州铜山区、新城区、经济技术开发区所属国资公司共同出资</div>
                </div>
                <div style="clear: both;"></div>
              </div>
              <div class="newNoticeItem">
                <div class="newNoticeItemDate">
                  <div class="newNoticeItemDay">02</div>
                  <div class="newNoticeItemYear">2020年6月</div>
                </div>
                <div class="newNoticeRight">
                  <span class="newNoticeTitle">徐州市城市轨道交通有限责任公司</span><br />
                  <div class="newNoticeContent">徐州市城市轨道交通有限责任公司（以下简称“轨道公司”）成立于2012年7月30日，注册资本61.625亿元人民币，由市政府授权市国资委及徐州铜山区、新城区、经济技术开发区所属国资公司共同出资</div>
                </div>
                <div style="clear: both;"></div>
              </div>
            </div>
            <div class="moreNotice" style="display:none">
              更多公告 >
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <!--
    <img :src="bg" :height="bgHeight" class="home-bg" >
    <div class="search-box-container" style="width: 375px;margin-left: -187.5px;left: 50%;">
      <el-input v-model="keyword" placeholder="请输入内容" class="input-with-select">
        <el-select slot="prepend" v-model="select" style="width: 110px" placeholder="请选择">
          <el-option label="社会招聘" value="/social"/>
          <el-option label="校园招聘" value="/campus"/>
        </el-select>
        <el-button slot="append" icon="el-icon-search" @click="search" />
      </el-input>
    </div>
    -->
  </section>
</template>
<script>
import Bg from 'assets/images/home-black-bg.jpg'
import Banner1 from 'assets/PC/banner_home.png'
import { getHotList, getJianjie } from 'api/recruit'
export default {
  data: () => {
    return {
      bg: Bg,
      bgHeight: '200px',
      keyword: '',
      select: '/social',
      hotRecruitData: [],
      banner1: Banner1,
      showStatus: false,
      Jianjie: null,
      JianjieCon: null,
      JianJieAll: null,
      btnText: '查看更多',
      textJson: {
        0: '查看更多',
        1: '收起'
      }
    }
  },
  created() {
    this.initHeight()
    window.onresize = () => {
      this.initHeight()
    }
    this._getHotList()
    this._getJianjie()
  },
  methods: {
    toggleJianJie() {
      if (this.showStatus) {
        this.JianjieCon = this.Jianjie
        this.showStatus = false
        this.btnText = this.textJson[0]
      } else {
        this.JianjieCon = this.JianJieAll
        this.showStatus = true
        this.btnText = this.textJson[1]
      }
    },
    initHeight() {
      this.bgHeight = document.body.clientHeight - 61
    },
    jumpTo(id) {
      this.$router.push({path: '/recruit/'+id})
    },
    jumpMore() {
      this.$router.push({path: '/recruit'})
    },
    search() {
      if (this.keyword === '') {
        this.$message.error({
          message: '请输入搜索内容'
        })
        return false
      }
      var path = this.select
      this.$router.push({
        path: path + '/' + this.keyword
      })
    },
    _getHotList() {
      getHotList().then((data) => {
        if (data.code > 0) {
          this.hotRecruitData = data.data
        }
      })
    },
    _getJianjie() {
      getJianjie().then(
        (data) => {
          this.JianJieAll = data.data[0].configValue
          this.Jianjie = data.data[0].configValue.substring(0, 352) + '...'
          this.JianjieCon = this.Jianjie
        }
      )
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/home/index.vue